import React, { useContext } from "react";
import { Button } from "@mui/material";
import { PageContent, QuestionnaireScreen } from "../../components";
import { useParams, useNavigate } from "react-router-dom";

import { AppContext } from "../../context/AppContext";
import { useTranslation } from "react-i18next";

const StrategyQuestions = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { allAnswered } = useContext(AppContext);
  const handleBackClick = () => {
    navigate("/ActionPlan");
  };
  const handleNextClick = () => {
    navigate("/ActionPlan");
  };

  return (
    <PageContent title="Strategy Questions">
      <QuestionnaireScreen questionnaireId={id} />
      <Button
        variant="contained"
        color="primary"
        onClick={handleBackClick}
        style={{ marginTop: "20px", marginRight: "13px" }}
      >
        {t("button_back")}
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={handleNextClick}
        style={{ marginTop: "20px", marginRight: "13px" }}
        disabled={!allAnswered(id)}
        sx={{ opacity: allAnswered(id) ? 1 : 0.5 }}
      >
        {t("button_next")}
      </Button>
    </PageContent>
  );
};

export default StrategyQuestions;
